import { SYSTEM_PROPERTIES_SET } from '../constants/systemPropertiesTypes';

const initialState = {
  returnReasons: [],
};

const systemProperties = (state = initialState, action) => {
  switch (action.type) {
    case SYSTEM_PROPERTIES_SET:
      return {
        ...state,
        [action.payload.type]: action.payload.data,
      };

    default:
      break;
  }

  return state;
};

export default systemProperties;
